import { render, staticRenderFns } from "./fechaComponent.vue?vue&type=template&id=27550628"
import script from "./fechaComponent.vue?vue&type=script&lang=js"
export * from "./fechaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports